import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
// enum LibraryTypeEnum {
//   // 人像库
//   PORTRAIT_LIBRARY = 'PORTRAIT_LIBRARY',
//   // 车辆库
//   AUTO_FEATURE = 'AUTO_FEATURE',
// }
let FileUpload = class FileUpload extends VuexModule {
    selectedRow = [];
    registry_id = 'default';
    bucket_name = 'bulk-tool-bucket';
    object_name = 'o2';
    upload_Id = '';
    libray_id = '';
    task_id = '';
    uploading = false;
    uploadPer = 0;
    async initializeFile(id) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/upload/v1/registries/${id}/multipart_upload`,
                data: {
                    registry_id: this.registry_id,
                    bucket_name: this.bucket_name,
                    object_name: this.object_name,
                },
            });
            this.updateUploadId(res.data.upload_id);
        }
        catch (e) {
            throw e;
        }
    }
    async finishUpload(completed_parts) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/upload/v1/registries/${this.registry_id}/multipart_upload/${this.upload_Id}/complete`,
                data: {
                    registry_id: this.registry_id,
                    bucket_name: this.bucket_name,
                    object_name: this.object_name,
                    upload_Id: this.upload_Id,
                    complete_parts: completed_parts,
                },
            });
            return res;
        }
        catch (e) {
            throw e;
        }
    }
    async deleteUpload() {
        try {
            const res = await ajax.request({
                method: 'DELETE',
                url: `/upload/v1/registries/${this.registry_id}/multipart_upload/${this.upload_Id}`,
            });
        }
        catch (e) {
            throw e;
        }
    }
    async checkUploaded(data) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/upload/v1/registries/${data.registry_id}/multipart_upload/incomplete/buckets/${data.bucket_name}/objects/${data.object_name}`,
            });
            console.log('res:', res);
        }
        catch (e) {
            throw e;
        }
    }
    async initPortraitLibPass(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/pass/portraitLib/create',
                data: { maxSize: '', name: data.libName, personGroup: data.type, remark: '' },
            });
            console.log('res:', res.data.data.libId);
            const libraryid = res.data.data.libId;
            this.updateLibrayId(libraryid);
        }
        catch (e) {
            throw e;
        }
    }
    async initPortraitLibAlert(libName) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/alert/portraitLib/add',
                data: { maxSize: '', name: libName, remark: '' },
            });
            console.log('res:', res.data.data.libId);
            const libraryid = res.data.data.libId;
            this.updateLibrayId(libraryid);
        }
        catch (e) {
            throw e;
        }
    }
    async getAllPortraitsAlert() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/portrait-management/api/v1/portraitlib/list',
            });
            console.log('res:', res);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getAllPortraitsPass(data) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/portrait-management/api/v1/pass/portraitLib/query/group',
                params: { onlyUserCreate: true, userGroup: data },
            });
            console.log('res:', res);
            return res?.data?.data;
        }
        catch (e) {
            throw e;
        }
    }
    async createTask(data) {
        console.log('create:', { ...data, libraryId: this.libray_id });
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/batch/task',
                data: { ...data, libraryId: this.libray_id },
            });
            console.log('res:', res);
            this.updateTaskId(res.data.data.taskId);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updateTask(data) {
        try {
            const res = await ajax.request({
                method: 'PATCH',
                url: '/api/portrait-management/api/v1/batch/task',
                data: { taskId: data.id ? data.id : this.task_id, state: data.state },
            });
        }
        catch (e) {
            throw e;
        }
    }
    async batchTask() {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/batch',
                data: { bucketName: this.bucket_name, objectName: this.object_name, taskId: this.task_id },
            });
        }
        catch (e) {
            throw e;
        }
    }
    async getUserNames(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/batch/username',
                data: data
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async checkLibByNamePass(checkName) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/portrait-management/api/v1/pass/portraitLib/exist/',
                data: { name: checkName },
            });
            console.log('res:', res);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async checkLibByNameAlert(checkName) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/portrait-management/api/v1/alert/portraitLib/exist/',
                data: { name: checkName },
            });
            console.log('res:', res);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    updateUploadId(payload) {
        console.log('upload:', payload);
        this.upload_Id = payload;
    }
    updateSelectedRow(payload) {
        this.selectedRow = payload;
    }
    updateObjectName(payload) {
        this.object_name = payload;
    }
    updateLibrayId(payload) {
        this.libray_id = payload;
    }
    updateTaskId(payload) {
        this.task_id = payload;
    }
    updateUploading(payload) {
        this.uploading = payload;
    }
    updateUploadPer(payload) {
        this.uploadPer = payload;
    }
    reset() {
        this.upload_Id = '';
        this.libray_id = '';
        this.task_id = '';
        this.uploading = false;
    }
};
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "initializeFile", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "finishUpload", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "deleteUpload", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "checkUploaded", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "initPortraitLibPass", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "initPortraitLibAlert", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "getAllPortraitsAlert", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "getAllPortraitsPass", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "createTask", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "updateTask", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "batchTask", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "getUserNames", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "checkLibByNamePass", null);
__decorate([
    Action({ rawError: true })
], FileUpload.prototype, "checkLibByNameAlert", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateUploadId", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateSelectedRow", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateObjectName", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateLibrayId", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateTaskId", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateUploading", null);
__decorate([
    Mutation
], FileUpload.prototype, "updateUploadPer", null);
__decorate([
    Mutation
], FileUpload.prototype, "reset", null);
FileUpload = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/fileUpload' })
], FileUpload);
export const FileUploadModule = getModule(FileUpload);
